(function(){
  'use strict';
  if(window.SanoCustomerPrivacy)return;
  // Translate the native Shopify UI in place. Its buttons, inputs and consent
  // listeners remain owned by Shopify; no second consent store is created.
  var texts={
    '#shopify-pc__banner__body-title':'Jouw privacy',
    '#shopify-pc__banner__btn-accept':'Alles accepteren',
    '#shopify-pc__banner__btn-decline':'Alles weigeren',
    '#shopify-pc__banner__btn-manage-prefs span':'Voorkeuren instellen',
    '#shopify-pc__banner__body-policy-link':'Privacyverklaring',
    '#shopify-pc__prefs__header-title':'Cookie- en privacyvoorkeuren',
    '#shopify-pc__prefs__header-accept':'Alles accepteren',
    '#shopify-pc__prefs__header-decline':'Alles weigeren',
    '#shopify-pc__prefs__header-save':'Mijn keuzes opslaan',
    '.shopify-pc__prefs__intro-main h3':'Jij bepaalt',
    '.shopify-pc__prefs__intro-main p':'Kies welke cookies we mogen gebruiken. Je kunt je voorkeuren later altijd aanpassen.'
  };
  var categories={
    essential:['Noodzakelijk','Deze cookies laten de webshop werken, bijvoorbeeld bij inloggen, je winkelwagen en afrekenen.'],
    preferences:['Personalisatie','Deze cookies onthouden je voorkeuren om een volgend bezoek persoonlijker te maken.'],
    marketing:['Marketing','Met jouw toestemming gebruiken wij en onze partners, waaronder Shopify, deze cookies voor relevante aanbiedingen en advertenties.'],
    analytics:['Analytisch','Met jouw toestemming helpen deze cookies ons te begrijpen hoe bezoekers de webshop gebruiken en waar we die kunnen verbeteren.']
  };
  function text(node,value){if(node&&node.textContent!==value)node.textContent=value;}
  function translate(){
    Object.keys(texts).forEach(function(selector){text(document.querySelector(selector),texts[selector]);});
    var banner=document.querySelector('#shopify-pc__banner');
    if(banner){
      banner.lang='nl';observer.observe(banner,{childList:true,subtree:true,characterData:true});
      var paragraph=banner.querySelector('.shopify-pc__banner__body p');
      if(paragraph&&!paragraph.dataset.sanoTranslated){
        var policy=paragraph.querySelector('a');
        paragraph.replaceChildren(document.createTextNode('Sano Nutrition gebruikt cookies om de webshop goed te laten werken. Met jouw toestemming gebruiken wij en onze partners, waaronder Shopify, ook cookies voor een persoonlijke ervaring, relevante advertenties en inzicht in het gebruik van onze webshop. Jij kiest welke cookies je toestaat. Lees meer in onze '));
        if(policy)paragraph.appendChild(policy);
        paragraph.dataset.sanoTranslated='true';
      }
    }
    var prefs=document.querySelector('#shopify-pc__prefs');if(prefs){prefs.lang='nl';observer.observe(prefs,{childList:true,subtree:true,characterData:true});}
    var close=document.querySelector('#shopify-pc__prefs__header-close');if(close)close.setAttribute('aria-label','Voorkeuren sluiten');
    Object.keys(categories).forEach(function(key){
      var option=document.querySelector('#shopify-pc__prefs__'+key);if(!option)return;
      var label=option.querySelector('label'),value=categories[key];
      // Preserve the checkbox and its native event binding.
      if(label){var first=Array.from(label.childNodes).find(function(node){return node.nodeType===3;});if(first&&first.data!==value[0])first.data=value[0];}
      text(option.querySelector('p'),value[1]);
    });
  }
  var queued=false;
  var observer=new MutationObserver(function(records){
    if(queued||!records.some(function(record){return (record.target.closest&&record.target.closest('#shopify-pc__banner,#shopify-pc__prefs'))||Array.from(record.addedNodes).some(function(node){return node.nodeType===1&&(node.matches('#shopify-pc__banner,#shopify-pc__prefs')||node.querySelector('#shopify-pc__banner,#shopify-pc__prefs'));});}))return;
    queued=true;queueMicrotask(function(){queued=false;translate();});
  });
  function start(){translate();observer.observe(document.body,{childList:true});}
  function openPreferences(){
    if(window.privacyBanner&&typeof window.privacyBanner.showPreferences==='function')return Promise.resolve(window.privacyBanner.showPreferences());
    return Promise.reject(new Error('Cookievoorkeuren zijn nog niet geladen. Probeer het opnieuw.'));
  }
  window.SanoCustomerPrivacy={openPreferences:openPreferences};
  document.addEventListener('click',function(event){var button=event.target.closest('[data-sano-cookie-preferences]');if(!button)return;event.preventDefault();openPreferences().catch(function(){button.textContent='Probeer cookievoorkeuren opnieuw';});});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  addEventListener('pagehide',function(){observer.disconnect();});
  addEventListener('pageshow',function(event){if(event.persisted)start();});
})();
